export default "__VITE_ASSET__CmRX27d3__"